export default "__VITE_ASSET__BiHiziS$__"